import Vue from 'vue';
import Component from 'vue-class-component';
import SidebarComponent from '@/components/sidebar/sidebar.component.vue';
import HeaderComponent from '@/components/header/header.component.vue';
import LoaderComponent from '@/components/loader/loader.component.vue';
import ModalPermissionsComponent from '@/components/modal-permissions/modal-permissions.component.vue';
import ModalLoginComponent from '@/components/modal-login/modal-login.component.vue';
//service
import SkillService from '@/core/services/skill.service.ts';
import SidebarService from '@/core/services/sidebar.service.ts';

@Component({
  components: {
    SidebarComponent,
    HeaderComponent,
    ModalPermissionsComponent,
    ModalLoginComponent,
    LoaderComponent
  }
})
export default class EditSkillComponent extends Vue {

  skillService: any = new SkillService();
  sidebarService: any = new SidebarService();
  genericErr: any = [];
  isLoading: boolean = false;
  logInModal: boolean = false;
  showModal: boolean = false;
  isSuccess: boolean = false;
  isErrorServer: boolean = false;
  modal: boolean = false;
  error: boolean = false;
  name: string = "";
  scores: any = [];
  value: string = "";
  percentage: string = "";
  description: string = "";

  mounted (){
    const _ = this;
    _.getById();
  }

  closeSidebar(){
    const _ = this;
    _.sidebarService.close();
  }

  edit(){
    const _ = this;
    let skill = {
      name: _.name,
      scores: [
        {
          value: _.value,
          percentage: _.percentage
        },
      ]
    };
    console.log(skill);
    let idSkill: any = location.href.split("/");
    idSkill = idSkill[5];
    _.isLoading = true;
    _.skillService.edit(skill, idSkill).then((data: any) => {
      _.isSuccess = true;
      _.isErrorServer = false;
      _.error = false;
      _.modal = true;
      setTimeout(() => {
        _.isLoading = false;
        _.$router.push('/skill');
      }, 1500)
    })
    .catch((err: any) => {
      _.modal = true;
      _.error = true;
      _.isErrorServer = true;
      setTimeout(() => {
        _.isLoading = false;
      }, 1500)
    })
  }

  getById(){
    const _ = this;
    let idSkill: any = location.href.split("/");
    idSkill = idSkill[5];
    _.isLoading = true;
    _.skillService.getById(idSkill).then((data: any) => {
      setTimeout(() => {
        _.isLoading = false;
      }, 1500)
      _.name = data["data"].skill.name;
      _.value = data["data"].skill.scores[0].value;
      _.percentage = data["data"].skill.scores[0].percentage;
    })
    .catch((err: any) => {
      if(err.response.data.message.includes('Invalid or inexistent user')){
        localStorage.removeItem('tk_auth');
        _.logInModal = true;
        console.log(_.logInModal, '_.logInModal')
      }
      setTimeout(() => {
        _.isLoading = false;
      }, 1500)
    })
  }

  validations(name = ''){
    const _ = this;
    _.genericErr = [];
    if(name == ''){
      _.genericErr.push("Por favor escribe el giro");
    }
    if(_.genericErr.length > 0){
      _.modal = true;
      _.error = true;
      return;
    }
    _.edit()
  }
}
